<template>
  <div class="w-full h-full fs-exclude flex items-center justify-center pointer-events-none select-none">
    <div class="w-full">
      <vue-marquee-slider
        :id="sliderId"
        v-lazy-container="{ selector: 'img' }"
        :speed="speed"
        :space="space"
        :auto-width="true"
      >
        <img
          v-for="(slide, index) in media"
          :key="index"
          :alt="slide.alt"
          :data-src="getAssetUrl(slide.image)"
          :class="imageClass"
        />
      </vue-marquee-slider>
    </div>
    <div
      :class="shadowClass"
      class="absolute -left-0.5 bottom-0 bg-gradient-to-r from-ocean to-transparent w-24 h-full"
    />
    <div
      :class="shadowClass"
      class="absolute -right-0.5 bottom-0 bg-gradient-to-l from-ocean to-transparent w-24 h-full"
    />
  </div>
</template>

<script>
import { VueMarqueeSlider } from 'vue-marquee-slider';
import { mapGetters } from 'vuex';

import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterLogoSlider',

  components: { VueMarqueeSlider },

  props: {
    media: {
      type: Array,
      default: () => [],
    },
    sliderId: {
      type: String,
      default: 'logo-slider',
    },
    imageClass: {
      type: String,
      default: 'w-auto',
    },
    shadowClass: {
      type: String,
      default: '',
    },
    speed: {
      type: Number,
      default: 35000,
    },
    space: {
      type: Number,
      default: 50,
    },
  },

  computed: {
    ...mapGetters(['getSiteLocale']),
  },

  methods: {
    getAssetUrl,
  },
};
</script>
